import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, CheckIcon, AlertCircleIcon, ArrowRightIcon, TagIcon, PackageIcon, DollarSignIcon, ShoppingBagIcon, BoxIcon } from 'lucide-react';
const sampleProduct = {
  title: 'Black Wireless Headphones Pro',
  sku: 'ELEC-0001',
  price: 149.99,
  imageUrl: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
  amazonProduct: {
    title: 'Black Wireless Headphones Pro - Amazon Edition',
    asin: 'B01ABCDEF',
    price: 159.99,
    imageUrl: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    rating: 4.5,
    reviewCount: 1234
  }
};
const ModernSplitLayout = () => <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200" data-id="element-582">
    <div className="p-3 border-b border-gray-100 bg-gray-50 flex items-center justify-between" data-id="element-583">
      <div className="flex items-center space-x-2" data-id="element-584">
        <CheckIcon className="h-4 w-4 text-green-500" data-id="element-585" />
        <h3 className="text-sm font-medium text-gray-700" data-id="element-586">Perfect Match</h3>
      </div>
    </div>
    <div className="p-4" data-id="element-587">
      <div className="grid grid-cols-2 gap-8" data-id="element-588">
        <div className="space-y-4" data-id="element-589">
          <div className="flex items-center space-x-2 mb-4" data-id="element-590">
            <ShoppingBagIcon className="h-5 w-5 text-[#7AB55C]" data-id="element-591" />
            <span className="font-medium text-gray-700" data-id="element-592">Shopify</span>
          </div>
          <div className="w-24 h-24 rounded-lg overflow-hidden bg-gray-100" data-id="element-593">
            <img src={sampleProduct.imageUrl} alt={sampleProduct.title} className="w-full h-full object-cover" data-id="element-594" />
          </div>
          <div className="space-y-2" data-id="element-595">
            <div className="flex items-center space-x-2" data-id="element-596">
              <PackageIcon className="h-4 w-4 text-gray-400" data-id="element-597" />
              <span className="text-gray-600" data-id="element-598">{sampleProduct.title}</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-599">
              <TagIcon className="h-4 w-4 text-gray-400" data-id="element-600" />
              <span className="text-gray-600" data-id="element-601">SKU: {sampleProduct.sku}</span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-602">
              <DollarSignIcon className="h-4 w-4 text-gray-400" data-id="element-603" />
              <span className="text-gray-600" data-id="element-604">${sampleProduct.price}</span>
            </div>
          </div>
        </div>
        <div className="space-y-4" data-id="element-605">
          <div className="flex items-center space-x-2 mb-4" data-id="element-606">
            <BoxIcon className="h-5 w-5 text-[#FF9900]" data-id="element-607" />
            <span className="font-medium text-gray-700" data-id="element-608">Amazon</span>
          </div>
          <div className="w-24 h-24 rounded-lg overflow-hidden bg-gray-100" data-id="element-609">
            <img src={sampleProduct.amazonProduct.imageUrl} alt={sampleProduct.amazonProduct.title} className="w-full h-full object-cover" data-id="element-610" />
          </div>
          <div className="space-y-2" data-id="element-611">
            <div className="flex items-center space-x-2" data-id="element-612">
              <PackageIcon className="h-4 w-4 text-gray-400" data-id="element-613" />
              <span className="text-gray-800" data-id="element-614">
                {sampleProduct.amazonProduct.title}
              </span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-615">
              <TagIcon className="h-4 w-4 text-gray-400" data-id="element-616" />
              <span className="text-gray-800" data-id="element-617">
                ASIN: {sampleProduct.amazonProduct.asin}
              </span>
            </div>
            <div className="flex items-center space-x-2" data-id="element-618">
              <DollarSignIcon className="h-4 w-4 text-gray-400" data-id="element-619" />
              <span className="text-gray-800" data-id="element-620">
                ${sampleProduct.amazonProduct.price}
              </span>
            </div>
            <div className="flex items-center space-x-3" data-id="element-621">
              <div className="flex items-center text-yellow-500" data-id="element-622">
                <StarIcon className="h-4 w-4 fill-current" data-id="element-623" />
                <span className="ml-1 text-sm" data-id="element-624">
                  {sampleProduct.amazonProduct.rating}
                </span>
              </div>
              <span className="text-xs text-gray-500" data-id="element-625">
                {sampleProduct.amazonProduct.reviewCount.toLocaleString()}{' '}
                reviews
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>;
const ConnectedLayout = () => <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200" data-id="element-626">
    <div className="p-3 border-b border-gray-100 bg-gray-50 flex items-center justify-between" data-id="element-627">
      <div className="flex items-center space-x-2" data-id="element-628">
        <CheckIcon className="h-4 w-4 text-green-500" data-id="element-629" />
        <h3 className="text-sm font-medium text-gray-700" data-id="element-630">Perfect Match</h3>
      </div>
    </div>
    <div className="p-4" data-id="element-631">
      <div className="flex items-stretch mb-4" data-id="element-632">
        <div className="flex-1 pr-8" data-id="element-633">
          <div className="flex items-center space-x-2" data-id="element-634">
            <ShoppingBagIcon className="h-5 w-5 text-[#7AB55C]" data-id="element-635" />
            <span className="font-medium text-gray-700" data-id="element-636">Shopify</span>
          </div>
        </div>
        <div className="px-8" data-id="element-637">
          <span className="text-xs text-blue-500" data-id="element-638">Match</span>
        </div>
        <div className="flex-1 pl-8" data-id="element-639">
          <div className="flex items-center space-x-2" data-id="element-640">
            <BoxIcon className="h-5 w-5 text-[#FF9900]" data-id="element-641" />
            <span className="font-medium text-gray-700" data-id="element-642">Amazon</span>
          </div>
        </div>
      </div>
      <div className="flex items-stretch" data-id="element-643">
        <div className="flex-1 pr-8 border-r border-gray-100" data-id="element-644">
          <div className="space-y-4" data-id="element-645">
            <div className="w-24 h-24 rounded-lg overflow-hidden bg-gray-100" data-id="element-646">
              <img src={sampleProduct.imageUrl} alt={sampleProduct.title} className="w-full h-full object-cover" data-id="element-647" />
            </div>
            <div className="space-y-2" data-id="element-648">
              <div className="flex items-center space-x-2" data-id="element-649">
                <PackageIcon className="h-4 w-4 text-gray-400" data-id="element-650" />
                <span className="text-gray-600" data-id="element-651">{sampleProduct.title}</span>
              </div>
              <div className="flex items-center space-x-2" data-id="element-652">
                <TagIcon className="h-4 w-4 text-gray-400" data-id="element-653" />
                <span className="text-gray-600" data-id="element-654">SKU: {sampleProduct.sku}</span>
              </div>
              <div className="flex items-center space-x-2" data-id="element-655">
                <DollarSignIcon className="h-4 w-4 text-gray-400" data-id="element-656" />
                <span className="text-gray-600" data-id="element-657">${sampleProduct.price}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="px-8 flex flex-col items-center justify-center" data-id="element-658">
          <div className="bg-blue-50 rounded-full p-2" data-id="element-659">
            <ArrowRightIcon className="h-4 w-4 text-blue-500" data-id="element-660" />
          </div>
        </div>
        <div className="flex-1 pl-8 border-l border-gray-100" data-id="element-661">
          <div className="space-y-4" data-id="element-662">
            <div className="w-24 h-24 rounded-lg overflow-hidden bg-gray-100" data-id="element-663">
              <img src={sampleProduct.amazonProduct.imageUrl} alt={sampleProduct.amazonProduct.title} className="w-full h-full object-cover" data-id="element-664" />
            </div>
            <div className="space-y-2" data-id="element-665">
              <div className="flex items-center space-x-2" data-id="element-666">
                <PackageIcon className="h-4 w-4 text-gray-400" data-id="element-667" />
                <span className="text-gray-800" data-id="element-668">
                  {sampleProduct.amazonProduct.title}
                </span>
              </div>
              <div className="flex items-center space-x-2" data-id="element-669">
                <TagIcon className="h-4 w-4 text-gray-400" data-id="element-670" />
                <span className="text-gray-800" data-id="element-671">
                  ASIN: {sampleProduct.amazonProduct.asin}
                </span>
              </div>
              <div className="flex items-center space-x-2" data-id="element-672">
                <DollarSignIcon className="h-4 w-4 text-gray-400" data-id="element-673" />
                <span className="text-gray-800" data-id="element-674">
                  ${sampleProduct.amazonProduct.price}
                </span>
              </div>
            </div>
            <div className="flex items-center space-x-3" data-id="element-675">
              <div className="flex items-center text-yellow-500" data-id="element-676">
                <StarIcon className="h-4 w-4 fill-current" data-id="element-677" />
                <span className="ml-1 text-sm" data-id="element-678">
                  {sampleProduct.amazonProduct.rating}
                </span>
              </div>
              <span className="text-xs text-gray-500" data-id="element-679">
                {sampleProduct.amazonProduct.reviewCount.toLocaleString()}{' '}
                reviews
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>;
const CompactLayout = () => <div className="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200" data-id="element-680">
    <div className="p-3 border-b border-gray-100 bg-gray-50 flex items-center justify-between" data-id="element-681">
      <div className="grid grid-cols-2 gap-8 w-full" data-id="element-682">
        <div className="flex items-center space-x-2" data-id="element-683">
          <ShoppingBagIcon className="h-5 w-5 text-[#7AB55C]" data-id="element-684" />
          <span className="font-medium text-gray-700" data-id="element-685">Shopify</span>
        </div>
        <div className="flex items-center space-x-2" data-id="element-686">
          <BoxIcon className="h-5 w-5 text-[#FF9900]" data-id="element-687" />
          <span className="font-medium text-gray-700" data-id="element-688">Amazon</span>
        </div>
      </div>
      <div className="flex items-center space-x-2 ml-4" data-id="element-689">
        <CheckIcon className="h-4 w-4 text-green-500" data-id="element-690" />
        <span className="text-sm text-gray-600" data-id="element-691">Perfect Match</span>
      </div>
    </div>
    <div className="p-4 space-y-4" data-id="element-692">
      <div className="grid grid-cols-2 gap-4" data-id="element-693">
        <div className="w-24 h-24 rounded-lg overflow-hidden bg-gray-100" data-id="element-694">
          <img src={sampleProduct.imageUrl} alt={sampleProduct.title} className="w-full h-full object-cover" data-id="element-695" />
        </div>
        <div className="w-24 h-24 rounded-lg overflow-hidden bg-gray-100" data-id="element-696">
          <img src={sampleProduct.amazonProduct.imageUrl} alt={sampleProduct.amazonProduct.title} className="w-full h-full object-cover" data-id="element-697" />
        </div>
      </div>
      <div className="space-y-3 border rounded-lg p-3 bg-gray-50" data-id="element-698">
        <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-699">
          <div className="flex items-center space-x-2" data-id="element-700">
            <PackageIcon className="h-4 w-4 text-gray-400" data-id="element-701" />
            <span className="text-gray-600" data-id="element-702">{sampleProduct.title}</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-703">
            <PackageIcon className="h-4 w-4 text-gray-400" data-id="element-704" />
            <span className="text-gray-800" data-id="element-705">
              {sampleProduct.amazonProduct.title}
            </span>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-706">
          <div className="flex items-center space-x-2" data-id="element-707">
            <TagIcon className="h-4 w-4 text-gray-400" data-id="element-708" />
            <span className="text-gray-600" data-id="element-709">SKU: {sampleProduct.sku}</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-710">
            <TagIcon className="h-4 w-4 text-gray-400" data-id="element-711" />
            <span className="text-gray-800" data-id="element-712">
              ASIN: {sampleProduct.amazonProduct.asin}
            </span>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-713">
          <div className="flex items-center space-x-2" data-id="element-714">
            <DollarSignIcon className="h-4 w-4 text-gray-400" data-id="element-715" />
            <span className="text-gray-600" data-id="element-716">${sampleProduct.price}</span>
          </div>
          <div className="flex items-center space-x-2" data-id="element-717">
            <DollarSignIcon className="h-4 w-4 text-gray-400" data-id="element-718" />
            <span className="text-gray-800" data-id="element-719">
              ${sampleProduct.amazonProduct.price}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>;
const ComparisonVariationsPage = () => {
  return <div className="min-h-screen bg-gray-100 py-12 px-4" data-id="element-720">
      <div className="max-w-7xl mx-auto space-y-8" data-id="element-721">
        <h1 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-722">
          Comparison Card Variations
        </h1>
        <div className="space-y-2" data-id="element-723">
          <h2 className="text-lg font-semibold text-gray-700" data-id="element-724">
            1. Modern Split Layout
          </h2>
          <ModernSplitLayout data-id="element-725" />
        </div>
        <div className="space-y-2" data-id="element-726">
          <h2 className="text-lg font-semibold text-gray-700" data-id="element-727">
            2. Connected Layout
          </h2>
          <ConnectedLayout data-id="element-728" />
        </div>
        <div className="space-y-2" data-id="element-729">
          <h2 className="text-lg font-semibold text-gray-700" data-id="element-730">
            3. Compact Layout
          </h2>
          <CompactLayout data-id="element-731" />
        </div>
      </div>
    </div>;
};
export default ComparisonVariationsPage;